import './loading-animation.scss';

const LoadingAnimation = ({ type }) => {
	const config = {
		'news-and-media': { numCards: 5, numItems: 4 },
		products: { numCards: 6, numItems: 4 },
		'news-and-events-filters': { numCards: 1, numItems: 6 },
		lang: { numCards: 1, numItems: 1 },
		'news-and-media-media-filters': { numCards: 5, numItems: 1 },
		'search-suggestions': { numCards: 5, numItems: 1 },
		panel: { numCards: 1, numItems: 6 },
		careers: { numCards: 4, numItems: 2 },
		card: { numCards: 1, numItems: 2 },
		compatibility: { numCards: 4, numItems: 4 },
	};

	const { numCards = 1, numItems = 1 } = config[type] || {};

	const cards = Array.from({ length: numCards }, (_, i) => (
		<div key={i} className="loading-animation__card">
			<div className="loading-animation__image"></div>
			<ul className="loading-animation__article">
				{Array.from({ length: numItems }, (_, j) => (
					<li key={j}></li>
				))}
			</ul>
		</div>
	));

	return (
		<div className={`loading-animation loading-animation--${type}`}>
			{cards}
		</div>
	);
};

export default LoadingAnimation;
